import { createLogger } from "@vao/shared-ui";

export default createLogger("vao-frontend-bo");
